import { URI } from '@/config/config';

export default async ({ rootState }) => {
  const url = new URL(`${URI}zones`);

  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };

  const response = await fetch(url, opts);
  const jsonResult = await response.json();

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult;
};
